import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';

import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import { SectionProvider } from './context/SectionContext';
import theme from './theme';

function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Set page title based on route
  useEffect(() => {
    const titles = {
      '/': 'Plannic - Architektur & CAD-Dienstleistungen',
      '/architecture': 'Architektur - Plannic',
      '/architecture/services': 'Architektur Leistungen - Plannic',
      '/architecture/references': 'Architektur Referenzen - Plannic',
      '/cad-services': 'CAD-Dienstleistungen - Plannic',
      '/cad-services/services': 'CAD Leistungen - Plannic',
      '/cad-services/references': 'CAD Referenzen - Plannic',
      '/about-us': 'Über uns - Plannic',
      '/contact': 'Kontakt - Plannic'
    };
    document.title = titles[location.pathname] || 'Plannic - CH';
  }, [location.pathname]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        width: '100%',
        overflowX: 'hidden'
      }}>
      {/* Skip to main content for accessibility */}
      <a href='#main-content' className='skip-to-main'>
        Zum Hauptinhalt springen
      </a>

      {!isLandingPage && <Header />}
      <Box
        id='main-content'
        component='main'
        tabIndex={-1}
        sx={{
          flex: 1,
          width: '100%',
          px: 0,
          py: 0,
          pt: 0,
          overflowX: 'hidden',
          '&:focus': {
            outline: 'none'
          }
        }}>
        <AppRoutes />
      </Box>
      {!isLandingPage && <Footer />}
    </Box>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <SectionProvider>
            <AppContent />
          </SectionProvider>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
